import { useEffect, useMemo, useState } from "react";
import { toast } from "react-toastify";
import InputForm from "../componentes/input/input";
import { FiBook } from "react-icons/fi";
import Pagination from "../componentes/pagination/Pagination";
import { Loading } from "../componentes/loading/loading";
import { Dropdown } from "primereact/dropdown";
import { Dialog } from "primereact/dialog";
import Button from "../componentes/button/button";
import InputFormat from "../componentes/inputMask/inputMask";

export default function CrudTemplate({ title, formFields, tableColumns, service, modalHeader, propsHeader }) {
  const [dados, setDados] = useState([]);
  const [form, setForm] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentPageData, setCurrentPageData] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    carregarLista();
    document.title = "MyDash | " + title;
  }, []);

  const dadosFiltrados = useMemo(() => {
    return dados.filter(value =>
      Object.values(value).some(val =>
        String(val).toLowerCase().includes(search.toLowerCase())
      )
    );
  }, [dados, search]);

  function carregarLista() {
    setLoading(true);
    service.listar()
      .then(res => setDados(res.data))
      .catch(err => console.error("Erro ao carregar lista: " + err))
      .finally(() => setTimeout(() => setLoading(false)), 400);
  }

  function salvarOuAtualizar(e) {
    e.preventDefault();

    if (isEdit) {
      service.atualizar(form.codigo || form.id, form)
        .then(() => {
          toast.success("Cadastro atualizado com sucesso!");
          carregarLista();
          setIsModalOpen(false);
        })
        .catch(err => console.error("Erro ao atualizar: " + err));
    } else {
      service.salvar(form)
        .then(() => {
          toast.success("Cadastro realizado com sucesso!");
          carregarLista();
          setIsModalOpen(false);
        })
        .catch(err => console.error("Erro ao salvar: " + err));
    }
  }

  function excluir(codigo) {
    if (!window.confirm("Deseja realmente excluir?")) return;
    service.excluir(codigo)
      .then(() => {
        toast.success("Exclusão realizada com sucesso!");
        carregarLista();
      })
      .catch(err => console.error("Erro ao excluir: " + err));
  }

  function handleChange(name, value) {
    setForm(prev => ({ ...prev, [name]: value }));
  }

  function abrirModal(value) {
    if (value) {
      setForm(value);
      setIsEdit(true);
    } else {
      setForm({});
      setIsEdit(false);
    }
    setIsModalOpen(true);
  }

  return (
    <div className="bg-gray-50 min-h-screen p-8">
      <div className="bg-white rounded-xl shadow-lg overflow-hidden">

        {/* Header */}
        <div className="bg-indigo-600 px-6 py-4">
          <div className="flex items-center justify-between">
            <h2 className="text-2xl font-bold text-white flex items-center gap-2">
              <FiBook className="w-6 h-6" />
              {title}
            </h2>
            <div className="flex">
              {propsHeader}
              <button
                onClick={() => abrirModal()}
                className="bg-white text-blue-600 px-4 py-2 rounded-lg font-medium hover:bg-blue-50 hover:shadow-md flex items-center"
              >
                <i className="fas fa-plus mr-2"></i> Adicionar
              </button>
            </div>
          </div>
        </div>
        <div className="p-6 border-b border-gray-200 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div className="col-12 col-md-5">

            <div className="relative">
              <div className="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
                <i className="fa fa-search text-gray-400" />
              </div>
              <input
                type="search"
                id="default-search"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="w-full px-3 py-2 pl-5 border border-gray-300 border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 transition"
                placeholder="Buscar por qualquer palavra..."
              />
            </div>
          </div>

          <div className="col-12 col-md-2">
            <div className="text-right">
              <p className="text-sm text-gray-500 mb-1">Total de registros</p>
              <p className="text-2xl font-bold text-indigo-600">{dadosFiltrados.length}</p>
            </div>
          </div>

        </div>
        {/* Table Section */}
        {loading ?
          <Loading />
          :
          <div className="table-responsive overflow-y-auto fade-in pb-6">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  {tableColumns.map(col => (
                    <th key={col.key} className={`px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider ${col.alignRight ? "text-right" : ""}`}>
                      {col.label}
                    </th>
                  ))}
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Ações
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {currentPageData.map((value, i) => (
                  <tr key={i} className="hover:bg-gray-50 transition">
                    {tableColumns.map(col => (
                      <td key={col.key} className={`px-6 py-4 whitespace-nowrap text-sm ${col.bold ? "font-medium text-gray-900" : "text-gray-500"} ${col.alignRight ? "text-right" : ""}`}>
                        {col.render ? col.render(value[col.key], value) : value[col.key]}
                      </td>
                    ))}
                    <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                      <div className="flex justify-end gap-2">
                        <i
                          onClick={() => abrirModal(value)}
                          className="fa fa-pencil-square text-indigo-600 hover:text-indigo-900 p-1 rounded-full hover:bg-indigo-50 cursor-pointer"
                        />
                        <i
                          onClick={() => excluir(value.codigo || value.id)}
                          className="fa fa-times  text-red-600 hover:text-red-900 p-1 rounded-full hover:bg-red-50 cursor-pointer"
                        />
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="mb-4">

              <Pagination
                data={dadosFiltrados}        // aqui passa o array filtrado
                length={currentPageData.length} // qtd mostrada na página
                currentData={setCurrentPageData} // recebe os dados da página
                pageSizeOptions={[20, 50, 100]}
              />
            </div>
          </div>
        }

        <Dialog
          header={isEdit ? "Atualizar " + modalHeader : "Cadastrar " + modalHeader}
          blockScroll={true}
          className="w-[95%]"
          visible={isModalOpen}
          onHide={() => setIsModalOpen(false)}
          footer={
            <div className="flex items-center justify-between w-full pt-3">
              <div className="flex gap-6">
                {formFields
                  .filter(field => field.type === "booleanFooter")
                  .map(field => (
                    <label
                      key={field.name}
                      className="flex items-center gap-2 text-sm font-medium text-gray-700 cursor-pointer"
                    >
                      <input
                        type="checkbox"
                        checked={!!form[field.name]}
                        onChange={(e) => handleChange(field.name, e.target.checked)}
                        className="w-4 h-4 text-indigo-600 rounded border-gray-300"
                      />
                      {field.label}
                    </label>
                  ))}
              </div>

              <div className="flex gap-2">
                <Button
                  onClick={() => setIsModalOpen(false)}
                  label="Cancelar"
                  iconLeft="fa fa-arrow-left"
                  variant="gray"
                />

                <Button
                  type="submit"
                  label={isEdit ? "Atualizar" : "Salvar"}
                  iconLeft="fa fa-plus"
                  variant="indigo"
                  onClick={salvarOuAtualizar}
                />
              </div>
            </div>
          }
        >

          <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-end p-4">
            {formFields
              .filter(field => field.type !== "booleanFooter")
              .map(field => (
                <div key={field.name} className={field.colSpan ? `md:col-span-${field.colSpan}` : ""}>
                  <label className="block text-sm font-medium text-gray-700 mb-1">{field.label}</label>
                  <div className="relative">
                    {field.type === "input" && (
                      <InputForm
                        type={field.typeText || 'text'}
                        placeholder={field.placeholder}
                        value={form[field.name] || ""}
                        disabled={field.disabled}
                        onChange={e => handleChange(field.name, e.target.value)}
                        onBlur={field.onBlur ? () => field.onBlur(form[field.name], handleChange, form) : undefined}
                      />
                    )}
                    {field.type === "inputMask" && (
                      <InputFormat
                        placeholder={field.placeholder}
                        value={form[field.name] || ""}
                        mask={field.mask}
                        disabled={field.disabled}
                        onChange={value => handleChange(field.name, value)}
                        onBlur={field.onBlur ? () => field.onBlur(form[field.name], handleChange, form) : undefined}
                      />
                    )}
                    {field.type === "select" && (
                      <Dropdown
                        value={form[field.name] || ""}
                        onChange={e => handleChange(field.name, e.target.value)}
                        options={field.options}
                        optionLabel="label"
                        optionValue="value"
                        className="w-full text-xs border"
                      />
                    )}
                    {field.type === "dropdown" && (
                      <Dropdown
                        value={form[field.name] || ""}
                        onChange={e => handleChange(field.name, e.target.value)}
                        options={field.options}
                        optionLabel={field.optionLabel}
                        filter
                        optionValue={field.optionValue}
                        virtualScrollerOptions={field.virtualize ? { itemSize: 38 } : undefined}
                        className="w-full text-xs border" />
                    )}
                    {/* 
                  {field.icon && (
                    <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                      {field.icon}
                    </div>
                  )} 
                   */}
                  </div>
                </div>
              ))}
          </div>

        </Dialog>
      </div>
    </div>
  );
}